import { AppIcons } from "../constants/app-icons";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
// import UserGemsService from "./user.gems.service";
export default class FileUploadDocumentService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = 169;
  icon = "EarthWithPurpleArrow";
  Width = 500;
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;

  gemItems = [
    {
      key: "uploadFile",
      label: "Upload Payable Documents",
      icon: AppIcons.DOCUMENT,
    },

    {
      key: "PrintCheck",
      label: "Print Check",
      icon: AppIcons.DOCUMENT,
    },
  ];

  constructor() {
    super("files");
  }
}
